import { withTheme } from '@emotion/react'
import React from 'react'
import GlobalCss from 'gatsby-theme-directv/src/components/CustomStyles/GlobalCss.styles'

const GlobalStyles = withTheme(() => (
  <>
    <GlobalCss />
  </>
))

export default GlobalStyles
